export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/recorderWorker.worker.js?_hash=12cfa948");
}
